import React, {useState} from "react";
import emailjs from "@emailjs/browser";
import "./ContactUsForm.css";
import {Input, MagneticButton} from "..";
import {Formik, Form} from "formik";
import * as Yup from "yup";

const ContactUsForm = () => {
  const [loading, setLoading] = useState(false);
  const [isSent, setIsSent] = useState(false);

  const handleEmailSend = (values, resetForm) => {
    setLoading(true);
    setIsSent(false);

    const serviceID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    const templateID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
    const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

    if (!serviceID || !templateID || !publicKey) {
      console.error("EmailJS environment variables are missing.");
      alert("Email service is not configured properly.");
      setLoading(false);
      return;
    }

    emailjs
      .send(
        serviceID,
        templateID,
        {
          from_name: values.name,
          to_name: "Deep Kapadia",
          from_email: values.email,
          to_email: "kapadia.deep12@gmail.com",
          subject: values.subject,
          message: values.message,
        },
        publicKey
      )
      .then(() => {
        setLoading(false);
        setIsSent(true);
        resetForm();

        // ✅ Revert back to "Submit" after 3 seconds
        setTimeout(() => {
          setIsSent(false);
        }, 3000);
      })
      .catch((error) => {
        setLoading(false);
        console.error("EmailJS error:", error);
        alert("Failed to send. Please try again.");
      });
  };

  return (
    <section className="contact-us-section section">
      <div className="contact-us-container container">
        <div className="contact-us-wrapper">
          <div className="contact-us-form">
            <Formik
              initialValues={{
                name: "",
                email: "",
                subject: "",
                message: "",
              }}
              validationSchema={Yup.object({
                name: Yup.string().required("Name is required"),
                email: Yup.string()
                  .email("Invalid email address")
                  .required("Email is required"),
                subject: Yup.string().required(
                  "Please select what would you like to talk about? *"
                ),
                message: Yup.string().required("Please write your message"),
              })}
              onSubmit={(values, {resetForm}) => {
                handleEmailSend(values, resetForm);
              }}
            >
              <Form>
                <Input
                  label="What's your name? *"
                  name="name"
                  number="01"
                  placeholder="Your name"
                />
                <Input
                  label="What's your email? *"
                  name="email"
                  number="02"
                  placeholder="Your email"
                />
                <Input
                  name="subject"
                  label="What would you like to talk about? *"
                  number="03"
                  type="selection"
                  options={["New Project", "Feedback", "Consultation", "Other"]}
                />
                <Input
                  label="Your Message"
                  name="message"
                  number="04"
                  type="textarea"
                  placeholder="Hello, can you help me with..."
                />
                {isSent && (
                  <div className="success-message">
                    <p>
                      🎉 Thank you for reaching out! Your message has been sent
                      successfully.
                      <br />
                      I’ll get back to you as soon as possible. 😊
                    </p>
                  </div>
                )}
                <button type="submit" className="submit-btn">
                  {loading ? "Sending..." : isSent ? "Message Sent " : "Submit"}
                </button>
              </Form>
            </Formik>
          </div>

          <div className="contact-us-text-contents">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M13.025 1l-2.847 2.828 6.176 6.176h-16.354v3.992h16.354l-6.176 6.176 2.847 2.828 10.975-11z"></path>
            </svg>
            <div className="info-texts">
              <h6>Let's Talk</h6>
              <p>
                You're just one click away from taking your brand or product
                from great to incredible. Fill out the form to share more
                details about your project.
              </p>
            </div>
            <div className="contact-details">
              <h6>Details</h6>
              <ul>
                <li>
                  <span className="icon">
                    <i className="fas fa-map-marker-alt"></i>
                  </span>
                  <a
                    href="https://maps.app.goo.gl/cDMgfV8LparnZJho6"
                    className="tt-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Surat, Gujarat, India
                  </a>
                </li>
                <li>
                  <span className="icon">
                    <i className="fas fa-phone"></i>
                  </span>
                  <a
                    href="tel:+919662520605"
                    className="tt-link"
                    target="_blank"
                  >
                    +(91) 96625 20605
                  </a>
                </li>
                <li>
                  <span className="icon">
                    <i className="fas fa-envelope"></i>
                  </span>
                  <a
                    href="mailto:contact@deepkapadia.work"
                    className="tt-link"
                    target="_blank"
                  >
                    contact@deepkapadia.work
                  </a>
                </li>
              </ul>
            </div>
            <div className="social-media-links">
              <h6>Social</h6>
              <ul>
                <li>
                  <MagneticButton>
                    <i className="fa-brands fa-facebook-f"></i>
                  </MagneticButton>
                </li>
                <li>
                  <MagneticButton>
                    <i className="fa-brands fa-instagram"></i>
                  </MagneticButton>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactUsForm;
